var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FBE9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.2344L13.2226 14.1884C12.1711 14.6833 11.5 15.7408 11.5 16.9029V22.881L18.7111 19.2755C18.9655 19.1483 19.2299 19.0499 19.5 18.9802V11.2344Z",
    fill: "#D42620"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18.9802C21.7701 19.0499 22.0345 19.1483 22.2889 19.2755L29.5 22.881V16.9029C29.5 15.7408 28.8289 14.6833 27.7774 14.1884L21.5 11.2344V18.9802Z",
    fill: "#D42620"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6056 21.0643L12.7603 24.487L19.9734 27.8814C20.1381 27.9589 20.3179 27.9991 20.5 27.9991C20.6821 27.9991 20.8619 27.9589 21.0266 27.8814L28.2397 24.487L21.3944 21.0643C20.8314 20.7828 20.1686 20.7828 19.6056 21.0643Z",
    fill: "#D42620"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureicon);
export default __webpack_public_path__ + "static/media/featureicon.d1c528019d8c337788bcec93c1408408.svg";
export { ForwardRef as ReactComponent };